// extracted by mini-css-extract-plugin
export default {"text-area-wrap":"style_text-area-wrap__Ptnun"};